import { Box, useTheme } from '@mui/material'
import { ReactComponent as Logo } from "assets/icon/something-wrong.svg";
import React from 'react'

const ErrorComponent: React.FC<{}> = (props) => {
    const theme = useTheme();
    return (<Box
        display='flex'
        alignItems='center'
        flexDirection='column'
        justifyContent='center'
        flex={1}
        sx={{
            "& svg": {
                width: "100%",
                maxWidth: 400,
                color: (theme) => theme.palette.primary.main,
            },
        }}
    >
        <Logo fill={theme.palette.primary.main}/>
        <Box component='h2' fontSize={30} mt={4}>
            Oh! Qualcosa è andato storto.
        </Box>
        <Box fontSize={18} textAlign='center'>
            Mentre cerchiamo di sistemare l'errore
        </Box>
        <Box fontSize={18} textAlign='center'>
            prova a ricaricare la pagina, se l'errore persiste contattaci
        </Box>
    </Box>)
}

export default ErrorComponent